/* ==========================================================================
   Media Mentions & Press Articles Data
   Comprehensive collection of all external news coverage, TV broadcasts, and press mentions
   ========================================================================== */

export const featuredPressHighlights = [
  {
    id: "plzen-cctv-expansion",
    publisher: "City of Pilsen (Plzeň.eu)",
    publisherLogo: "🏛️",
    title: "The City of Pilsen Expands Its Municipal CCTV & Acoustic Network",
    title_cs: "Plzeň rozšířila svůj městský kamerový systém o akustické detektory",
    quote: "“The city installed sound detectors and high-resolution cameras in new locations across street intersections and frequent movement areas to enhance rapid police response.”",
    quote_cs: "„Město nainstalovalo akustické detektory zvuku a kamery s vysokým rozlišením na nových místech na křižovatkách a frekventovaných prostranstvích.“",
    url: "https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/plzen-rozsirila-svuj-mestsky-kamerovy-system/",
    badge: "Municipal Security",
    category: "public-safety"
  },
  {
    id: "novinky-university-security",
    publisher: "Novinky.cz",
    publisherLogo: "📰",
    title: "University of West Bohemia Campus Guarded by Gunshot and Scream Detectors",
    title_cs: "Univerzitu v Plzni hlídají detektory střelby a panických výkřiků",
    quote: "“If gunshots or panic screams are heard on the campus of the University of West Bohemia in Plzeň, security forces know almost immediately thanks to 8 acoustic detectors.”",
    quote_cs: "„Pokud v areálu Západočeské univerzity v Plzni padnou výstřely nebo zazní panický křik, bezpečnostní složky se o tom dozvědí téměř okamžitě díky 8 detektorům SED.“",
    url: "https://www.novinky.cz/clanek/domaci-univerzitu-v-plzni-hlidaji-detektory-strelby-a-panickych-vykriku-40460042",
    badge: "Campus & Student Safety",
    category: "education"
  },
  {
    id: "ct-show-bilance",
    publisher: "Česká Televize (Bilance)",
    publisherLogo: "📺",
    title: "Czech TV Report: Show Bilance — Audio Event Detector in Practice",
    title_cs: "Reportáž České televize: Pořad Bilance — Jak funguje Sound Event Detector",
    quote: "“Reporters from Czech Television came to see for themselves the positive benefits of the SED detector in saving lives and protecting property against vandalism.”",
    quote_cs: "„Reportéři České televize se na vlastní oči i uši přesvědčili o pozitivních přínosech detektoru SED při záchraně lidských životů a ochraně majetku.“",
    url: "https://youtu.be/1ZbI0-uAkjA?si=FV_Z993s5by7pa8f",
    badge: "TV Broadcast & Video",
    category: "tv-report"
  },
  {
    id: "novinky-smart-cameras",
    publisher: "Novinky.cz",
    publisherLogo: "📰",
    title: "Intelligent Cameras See and Hear: Smart Technologies Transforming Cities",
    title_cs: "Inteligentní kamery vidí i slyší: chytré technologie mění česká města",
    quote: "“The Sound Event Detector (SED) from Jalud Embedded in Pilsen can be installed either as a stand-alone sensor or as embedded software directly inside IP cameras.”",
    quote_cs: "„Detektor zvukových událostí SED od firmy Jalud Embedded lze instalovat jak samostatně, tak softwarově přímo do kamerového systému bez dalších serverů.“",
    url: "https://www.novinky.cz/clanek/internet-a-pc-inteligentni-kamery-vidi-i-slysi-chytre-technologie-meni-ceska-mesta-40450506",
    badge: "Edge AI Technology",
    category: "innovation"
  }
];

export const allMediaArticles = [
  {
    publisher: "Plzeň.eu",
    publisherType: "official",
    title: "Awards in the Visionaries 2023 competition go to Pilsen for Jalud Embedded and Luděk Šantora",
    title_cs: "Plzeň — Ocenění v soutěži Vizionáři 2023 putují do Plzně pro Jalud Embedded a Luďka Šantoru",
    desc: "Prestigious national innovation award recognized for AI-driven acoustic security technology.",
    desc_cs: "Prestižní ocenění za technologickou inovaci pro systém Sound Event Detector a tým JALUD Embedded.",
    url: "https://plzen.eu/o-meste/aktuality/aktuality-z-mesta/oceneni-v-soutezi-vizionari-2023-putuji-do-plzne-pro-jalud-embedded-a-ludka-santoru/",
    tag: "Award: Visionaries 2023",
    category: "awards",
    year: "2023"
  },
  {
    publisher: "Plzeňská Drbna",
    publisherType: "press",
    title: "Special security sound detectors reacted to terrifying screams — Police intervention followed immediately",
    title_cs: "Na šílený řev reagovaly i speciální bezpečnostní detektory zvuku. Pak přišel zásah",
    desc: "Acoustic sensor alerted the police operations center to violent altercation in public park, enabling immediate tactical response.",
    desc_cs: "Akustický senzor SED v parku zachytil volání o pomoc a panický řev. Policie okamžitě zasáhla a zamezila eskalaci.",
    url: "https://plzenska.drbna.cz/krimi/18960-na-sileny-rev-reagovaly-i-specialni-bezpecnostni-detektory-zvuku-pak-prisel-zasah.html",
    tag: "Police Intervention & Life Saved",
    category: "public-safety",
    year: "2024"
  },
  {
    publisher: "Česká Televize (ČT24)",
    publisherType: "tv",
    title: "Risk of attacks on critical infrastructure is growing. Hospitals are the worst secured, says association",
    title_cs: "Česká televize (ČT24) — Riziko útoků na kritickou infrastrukturu roste. Nejhůře jsou zabezpečeny nemocnice",
    desc: "Investigation into healthcare vulnerabilities and the necessity of real-time aggression and threat detection.",
    desc_cs: "Reportáž ČT24 o zranitelnosti nemocnic a urgentních příjmů a nutnosti včasné detekce verbální agrese.",
    url: "https://ct24.ceskatelevize.cz/domaci/3511096-riziko-utoku-na-kritickou-infrastrukturu-roste-nejhure-jsou-zabezpeceny-nemocnice",
    tag: "Healthcare & Critical Infrastructure",
    category: "healthcare",
    year: "2022"
  },
  {
    publisher: "Plzeňská Drbna",
    publisherType: "press",
    title: "New smart cameras and acoustic sensors guard safety in city streets — Pilsen monitored by 238 cameras",
    title_cs: "Další nové kamery budou dohlížet na bezpečnost v ulicích města. Už teď hlídá Plzeň 238 kamer",
    desc: "Comprehensive smart city surveillance and acoustic threat detection integration in Western Bohemia.",
    desc_cs: "Rozšiřování městského dohledového centra v Plzni o chytré senzory SED pro detekci křiku a tříštění skla.",
    url: "https://plzenska.drbna.cz/krimi/12935-dalsi-nove-kamery-budou-dohlizet-na-bezpecnost-v-ulicich-mesta-uz-ted-hlida-plzen-238-kamer.html",
    tag: "Smart Safe City",
    category: "public-safety",
    year: "2023"
  },
  {
    publisher: "Plzeň.eu",
    publisherType: "official",
    title: "Pilsen receives Ministry of Interior subsidy to deploy gunshot, panic scream and glass break detectors",
    title_cs: "Plzeň získala dotaci na nasazení detektorů střelby, panických výkřiků a tříštění skla",
    desc: "Official city hall announcement on government crime prevention grant for advanced acoustic security network.",
    desc_cs: "Tisková zpráva Magistrátu města Plzně o získání státní dotace z programu prevence kriminality pro senzory SED.",
    url: "https://www.plzen.eu/o-meste/aktuality/aktuality-z-mesta/plzen-ziskala-dotaci-na-nasazeni-detektoru-strelby-panickych-vykriku-a-tristeni-skla.aspx",
    tag: "Crime Prevention Grant",
    category: "public-safety",
    year: "2023"
  },
  {
    publisher: "Stream.cz / Televize Seznam",
    publisherType: "tv",
    title: "Future Czechia: Security made of wires and chips — Acoustic AI in action",
    title_cs: "Seriál Česko budoucnosti: Ochranka z drátů a čipů — Akustická AI v praxi",
    desc: "Technology series exploring next-generation Czech AI innovations protecting smart cities and critical facilities.",
    desc_cs: "Dokumentární pořad Televize Seznam o chytrých českých technologiích a zvukových senzorech SED.",
    url: "https://www.stream.cz/zpravy-televize-seznam/serial-cesko-budoucnosti-ochranka-z-dratu-a-cipu-64369602",
    tag: "TV Documentary",
    category: "innovation",
    year: "2022"
  },
  {
    publisher: "Security Guide",
    publisherType: "industry",
    title: "A sharp live test of critical infrastructure security in the Czech Republic took place in Pilsen",
    title_cs: "V Plzni se uskutečnil ostrý test zabezpečení kritické infrastruktury v ČR. Jak dobře je chráněná?",
    desc: "Real-world simulation testing perimeter breach, drone intrusion, and physical attacks on energy infrastructure.",
    desc_cs: "Ostrý zátěžový test zabezpečení energetické a vodohospodářské infrastruktury s detektory SED a kamerami Axis.",
    url: "https://securityguide.cz/v-plzni-se-uskutecnil-ostry-test-zabezpeceni-kriticke-infrastruktury-v-ceske-republice-jak-dobre-je-chranena/",
    tag: "Critical Infrastructure Audit",
    category: "industrial",
    year: "2022"
  },
  {
    publisher: "Rmol.cz",
    publisherType: "industry",
    title: "Axis Communications and AK ICR organized live attack simulation on critical infrastructure",
    title_cs: "Axis a AK IČR s partnery uspořádali ostrý test útoku na kritickou infrastrukturu",
    desc: "Industry report on integrated security ecosystem combining Axis cameras, SED acoustic sensors, and VMS automated response.",
    desc_cs: "Článek o úspěšné integraci SED do ekosystému Axis Communications pro ochranu strategických objektů.",
    url: "https://www.rmol.cz/novinky/axis-ak-icr-s-partnery-usporadali-ostry-test-utoku-na-kritickou-infrastrukturu",
    tag: "Axis Partner Ecosystem",
    category: "industrial",
    year: "2022"
  },
  {
    publisher: "Security Magazín",
    publisherType: "industry",
    title: "How well protected is critical infrastructure in Czechia? Live security test conducted in Pilsen",
    title_cs: "Jak dobře je chráněná kritická infrastruktura v České republice? V Plzni se uskutečnil ostrý test jejího zabezpečení",
    desc: "Technical evaluation of multi-layered perimeter defense featuring acoustic gunshot, grinder, and drone detection.",
    desc_cs: "Odborná analýza testu perimetrické ochrany s využitím detekce úhlových brusek, dronů a střelby.",
    url: "https://www.securitymagazin.cz/security/jak-dobre-je-chranena-kriticka-infrastruktura-v-ceske-republice-v-plzni-se-uskutecnil-ostry-test-jejiho-zabezpeceni-1404068965.html",
    tag: "Security Technology Review",
    category: "industrial",
    year: "2022"
  },
  {
    publisher: "FEEDIT.cz",
    publisherType: "industry",
    title: "Critical infrastructure armoured against cyber-attacks, disruption of raw material supplies and sabotage",
    title_cs: "FEEDIT — Kritická infrastruktura zbrojí proti kybernetickým útokům, narušení dodávek surovin a sabotážím",
    desc: "Modernizing physical security to defend against hybrid threats, sabotage, and unauthorized perimeter access.",
    desc_cs: "Zabezpečení strategických podniků před fyzickou sabotáží a neoprávněným vniknutím pomocí zvukové analýzy.",
    url: "https://feedit.cz/2022/06/23/kriticka-infrastruktura-zbroji-proti-kybernetickym-utokum-naruseni-dodavek-surovin-a-sabotazim/",
    tag: "Anti-Sabotage & Perimeter",
    category: "industrial",
    year: "2022"
  },
  {
    publisher: "IToday.cz",
    publisherType: "industry",
    title: "Critical infrastructure armoured against attacks and sabotage with smart sensors",
    title_cs: "IToday — Kritická infrastruktura zbrojí proti kybernetickým útokům a sabotážím",
    desc: "Deploying AI-driven acoustic detectors to prevent vandalism and forced intrusion on high-voltage substations.",
    desc_cs: "Nasazení inteligentních detektorů SED pro prevenci narušení rozvoden a energetických uzlů.",
    url: "https://itoday.cz/kriticka-infrastruktura-zbroji-proti-kybernetickym-utokum-a-sabotazim/",
    tag: "Physical Security Tech",
    category: "industrial",
    year: "2022"
  },
  {
    publisher: "Plzeňská Drbna",
    publisherType: "press",
    title: "Association of Critical Infrastructure warns of attack risks threatening energy and utility supplies",
    title_cs: "Asociace kritické infrastruktury varuje před nebezpečím útoků na dodávky energií",
    desc: "Warning of vulnerability in energy distribution nodes and the vital role of acoustic intrusion monitoring.",
    desc_cs: "Varování před riziky napadení energetických sítí a význam automatické akustické detekce narušitelů.",
    url: "https://plzenska.drbna.cz/zpravy/9313-asociace-kriticke-infrastruktury-varuje-pred-nebezpecim-utoku-ktere-mohou-ohrozit-napriklad-dodavky-energii.html",
    tag: "Energy Grid Defense",
    category: "industrial",
    year: "2022"
  }
];
